<template>
  <div class="card-item">
    <div class="card-head">
      <div class="title">
        <span class="label">{{ metaTitle.label }}：</span>
        <span v-if="metaTitle.formatter" class="text">
          {{ metaTitle.formatter(data) }}
        </span>
        <span v-else class="text">{{ data[metaTitle.value] || $constants.EMPTY }}</span>
      </div>
      <div class="fill"></div>
      <div class="operate-wrap">
        <div
          v-for="(ele, index) in operator"
          v-show="
            (ele.auth ? $utils.hasAuth($store, ele.auth) : true) &&
              (ele.judgeShow ? ele.judgeShow(data, ele) : true)
          "
          :key="index"
          class="operate-item"
          @click="ele.click(data, ele)"
        >
          <div v-if="ele.showText">
            <span :class="['iconfont', ele.icon, 'operate-icon']"></span>
            <span class="operate-text">{{ ele.text }}</span>
          </div>
          <div v-else>
            <el-tooltip :content="ele.text" placement="top">
              <span :class="['iconfont', ele.icon, 'operate-icon']"></span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <el-row>
        <el-col
          v-for="(ele, index) in metaData"
          v-show="ele.judgeShow ? ele.judgeShow(data, ele) : true"
          :key="index"
          :span="ele.col"
          class="card-body-item"
        >
          <span class="label">{{ ele.label }}：</span>
          <template v-if="!ele.slotName">
            <el-tooltip
              v-if="ele.formatter"
              :content="`${ele.formatter(data)}`"
              placement="top"
              :disabled="shouldHide(`tooltip${index}`)"
            >
              <div :ref="`tooltip${index}`" class="text">
                <span>
                  {{ ele.formatter(data) }}
                </span>
              </div>
            </el-tooltip>
            <el-tooltip
              v-else
              :content="`${data[ele.value] || $constants.EMPTY}`"
              placement="top"
              :disabled="shouldHide(`tooltip${index}`)"
            >
              <div :ref="`tooltip${index}`" class="text">
                <span>{{ data[ele.value] || $constants.EMPTY }}</span>
              </div>
            </el-tooltip>
          </template>
          <template v-else>
            <slot :name="ele.slotName" :param="data"></slot>
          </template>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CardItem',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    metaTitle: {
      type: Object,
      default: () => {}
    },
    metaData: {
      type: Array,
      default: () => []
    },
    operator: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    shouldHide(tipRefName) {
      let node = this.$refs[tipRefName]
      if (node && node.length > 0 && node[0].children && node[0].children.length > 0) {
        return node[0].children[0].offsetWidth <= node[0].offsetWidth
      } else {
        return true
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'card-item',
  (
    --cbaas-card-item-head-background-color: #303c65,
    --cbaas-card-item-head-title-color: #fff,
    --cbaas-card-item-head-item-label-color: rgba(255, 255, 255, 0.65),
    --cbaas-card-item-body-background-color: #232d51,
    --cbaas-card-item-body-item-color: #fff,
    --cbaas-card-item-body-item-label-color: rgba(255, 255, 255, 0.65),
    --cbaas-card-item-hover-head-background-color: #49547a,
    --cbaas-card-item-hover-body-background-color: #2d3861,
    --cbaas-card-item-hover-border-color: #45c2ff,
    --cbaas-card-item-operate-item-color: #45c2ff
  ),
  (
    --cbaas-card-item-head-background-color: #45c2ff,
    --cbaas-card-item-head-title-color: #ffffff,
    --cbaas-card-item-head-item-label-color: #fff,
    --cbaas-card-item-body-background-color: #fff,
    --cbaas-card-item-body-item-color: #192227,
    --cbaas-card-item-body-item-label-color: #5a6973,
    --cbaas-card-item-hover-head-background-color: #45c1ffcc,
    --cbaas-card-item-hover-body-background-color: #ffffffcc,
    --cbaas-card-item-hover-border-color: #45c2ffcc,
    --cbaas-card-item-operate-item-color: #fff
  )
);
.card-item {
  @include adaptation(
    (
      --cbaas-card-item-head-padding: 11px 15px 12px,
      --cbaas-card-item-head-border-width: 1px,
      --cbaas-card-item-head-title-fontsize: 14px,
      --cbaas-card-item-head-title-line-height: 20px,
      --cbaas-card-item-head-operate-height: 16px,
      --cbaas-card-item-head-operate-icon-fontsize: 16px,
      --cbaas-card-item-head-operate-icon-margin-right: 4px,
      --cbaas-card-item-head-operate-text-fontsize: 12px,
      --cbaas-card-item-body-padding: 6px 15px 10px,
      --cbaas-card-item-body-border-width: 1px,
      --cbaas-card-item-body-item-fontsize: 12px,
      --cbaas-card-item-body-line-height: 28px
    )
  );
  .card-head {
    background-color: var(--cbaas-card-item-head-background-color);
    padding: var(--cbaas-card-item-head-padding);
    border-left: var(--cbaas-card-item-head-border-width) solid
      var(--cbaas-card-item-head-background-color);
    border-top: var(--cbaas-card-item-head-border-width) solid
      var(--cbaas-card-item-head-background-color);
    border-right: var(--cbaas-card-item-head-border-width) solid
      var(--cbaas-card-item-head-background-color);
    display: flex;

    .title {
      color: var(--cbaas-card-item-head-title-color);
      font-size: var(--cbaas-card-item-head-title-fontsize);
      font-weight: 500;
      line-height: var(--cbaas-card-item-head-title-line-height);

      .label {
        color: var(--cbaas-card-item-head-item-label-color);
        font-weight: 400;
      }
    }

    .fill {
      flex-grow: 1;
    }

    .operate-wrap {
      display: flex;
      align-items: center;
      .operate-item {
        height: var(--cbaas-card-item-head-operate-height);
        color: var(--cbaas-card-item-operate-item-color);

        .operate-icon {
          font-size: var(--cbaas-card-item-head-operate-icon-fontsize);
          margin-right: var(--cbaas-card-item-head-operate-icon-margin-right);
        }

        .operate-text {
          font-size: var(--cbaas-card-item-head-operate-text-fontsize);
          font-weight: 400;
        }
      }
    }
  }

  .card-body {
    background-color: var(--cbaas-card-item-body-background-color);
    padding: var(--cbaas-card-item-body-padding);
    border-left: var(--cbaas-card-item-body-border-width) solid
      var(--cbaas-card-item-body-background-color);
    border-right: var(--cbaas-card-item-body-border-width) solid
      var(--cbaas-card-item-body-background-color);
    border-bottom: var(--cbaas-card-item-body-border-width) solid
      var(--cbaas-card-item-body-background-color);

    .card-body-item {
      color: var(--cbaas-card-item-body-item-color);
      font-size: var(--cbaas-card-item-body-item-fontsize);
      line-height: var(--cbaas-card-item-body-line-height);
      display: flex;
      flex-direction: row;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;

      .label {
        color: var(--cbaas-card-item-body-item-label-color);
      }

      .text {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }

  &:hover {
    .card-head {
      background-color: var(--cbaas-card-item-hover-head-background-color);
      border-color: var(--cbaas-card-item-hover-border-color);
    }

    .card-body {
      background-color: var(--cbaas-card-item-hover-body-background-color);
      border-color: var(--cbaas-card-item-hover-border-color);
    }
  }
}
</style>
